/* eslint-disable react/react-in-jsx-scope */
// @ts-nocheck
import React, { useEffect } from 'react';
import Script from 'react-load-script';

const MIN_SLIDE_WIDTH = 320;
const SCENE_ID = '1x9f1lsa';
let captcha = null;

const parsePixelValue = value => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'string') {
    const parsed = Number.parseFloat(value);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }
  return undefined;
};

const AliScript = props => {
  const { awscId, data } = props ?? {};
  const parsedWidth = parsePixelValue(data?.width);
  const needsScale = parsedWidth !== undefined && parsedWidth < MIN_SLIDE_WIDTH;
  const slideWidth = needsScale ? MIN_SLIDE_WIDTH : data?.width || 300;
  const rem = needsScale && parsedWidth ? parsedWidth / MIN_SLIDE_WIDTH : 1;
  const slideHeight = rem < 1 ? 40 / rem : 40;

  useEffect(() => {
    // 设置验证码 2.0 全局配置
    window.AliyunCaptchaConfig = {
      region: 'cn',
      prefix: 'xxqllw',
    };
  }, []);

  const initCaptcha = () => {
    window.initAliyunCaptcha({
      SceneId: SCENE_ID,
      mode: 'embed',
      element: `#${awscId}`,
      button: `#${awscId}-button`,
      rem,
      delayBeforeSuccess: false,
      success: captchaVerifyParam => {
        data.success &&
          data.success({
            captchaVerifyParam,
            sceneId: SCENE_ID,
          });
      },
      fail: result => {
        data.fail && data.fail(result);
      },
      // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
      getInstance: function (instance) {
        captcha = instance;
      },
      slideStyle: {
        width: slideWidth || 300,
        height: slideHeight || 40,
      },
    });
  };

  const myLoad = () => {
    initCaptcha();
  };

  return (
    <>
      <div id={`${awscId}-button`} style={{ display: 'none' }} />
      <Script
        url="https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js"
        onLoad={myLoad}
      />
    </>
  );
};

export default AliScript;
